// Extract folder from landing with "/" Example: 'https://segurosdeviajes.mapfre.es/'
export const folderJSpath = window.location.origin + window.location.pathname
